import { MatDialog } from '@angular/material/dialog';
import { LogService } from '@pershing/pershing-core';
import { OrderProspectusFormComponent } from './order-prospectus-form.component';
import { Account, Quote } from '../../../models/common/trading-common.model';

export function openOrderProspectus(_account: Account, _quote: Quote, _dialog: MatDialog, _logService: LogService) {
    let isWindowBigSize = window.innerWidth > 1280;
    let dialogWidth = '80%';
    if (isWindowBigSize) {
        dialogWidth = '60%';
    }

    const orderProspectusDialogRef = _dialog.open(OrderProspectusFormComponent, {
        panelClass: 'modal',
        width: dialogWidth,
        disableClose: true,
        autoFocus: false,
        data: {
            account: _account,
            quote: _quote
        }
    });

    orderProspectusDialogRef.afterClosed().subscribe((data) => {
        _logService.log('The orderProspectusDialogRef was closed', data);
    });
}
